var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrderEquipment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8413 20.752H19.2919",
    stroke: "#39546A",
    strokeWidth: 1.35945,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20.4363L5.28825 22.1176L7.91904 18.7129",
    stroke: "#39546A",
    strokeWidth: 1.35945,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8794 15.4141H17.4187",
    stroke: "#39546A",
    strokeWidth: 1.35945,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.03809 15.0984L5.32633 16.7797L7.95713 13.375",
    stroke: "#39546A",
    strokeWidth: 1.35945,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8794 10.0391H19.3299",
    stroke: "#39546A",
    strokeWidth: 1.35945,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.03809 9.72339L5.32633 11.4047L7.95713 8",
    stroke: "#39546A",
    strokeWidth: 1.35945,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5544 13.9007C19.4654 13.5241 20.4678 13.9318 20.8557 14.774L22.8338 19.0693C23.0138 18.6497 23.3609 18.2907 23.8277 18.0976L23.8282 18.0975C24.6584 17.7546 25.5913 18.0502 26.0189 18.7539C26.1581 18.2372 26.5419 17.779 27.0926 17.5512H27.0932C27.9231 17.2087 28.8561 17.5042 29.2838 18.2077C29.423 17.6911 29.8068 17.2327 30.3579 17.0051C31.2689 16.6289 32.3533 17.0034 32.6591 17.8787L34.9087 24.319C36.7377 29.5557 30.2083 35.0779 25.3166 31.9124L16.8316 26.4223C16.0378 25.909 15.8556 24.8487 16.4264 24.0662C17.3298 23.6934 19.1166 23.7133 19.9158 24.2306L21.5228 25.2704L17.5434 16.1424C17.1731 15.2923 17.6435 14.2771 18.5544 13.9007Z",
    stroke: "#39546A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderEquipment);
export default __webpack_public_path__ + "static/media/OrderEquipment.1f3d7fbd518f356f2afe5b0e189e078d.svg";
export { ForwardRef as ReactComponent };